import { useState } from "react";
import { ResellerService } from "../../../services/ResellerService";
import { InputDefault } from "../../../components/forms/InputDefault";
import { EmployeePositionService } from "../../../services/EmployeePositionService";

export const EmployeePositionCreate = ({ open, setOpen, refreshData }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    name: "",
  });

  const [error, setError] = useState({
    name: "",
  });

  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.id]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    setError({
      name: "",
    });

    try {

      if (data.name.length < 1) {
        setError(prev => ({
          ...prev,
          name: "Nama tidak boleh kosong",
        }));
      } else {
        await EmployeePositionService.create({ data });
        setOpen(false);
        setData({
          name: "",
        });
        refreshData();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center bg-black p-5 ${open
        ? "bg-black/30 pointer-events-auto"
        : "bg-transparent pointer-events-none"
        }`}
    >
      <div
        className={` w-full max-w-[500px] bg-white shadow-xl rounded-xl flex flex-col gap-3 overflow-hidden transition-all duration-500 ${open ? "scale-100" : "scale-0"
          }`}
      >
        {/* Modal Header */}
        <div className="w-full flex items-center justify-center p-3 bg-gray-500 text-white">
          <p className="text-xl font-semibold">Tambah Posisi / Jabatan</p>
        </div>

        {/* Main Content */}
        <form
          className="w-full p-3 flex flex-col gap-3"
        >
          {/* Form Data */}
          <InputDefault
            id="name"
            label="Nama"
            type="text"
            placeholder="Masukkan nama posisi / jabatan"
            value={data.name}
            onChange={handleChange}
            error={error.name}
          />

          {/* Button Submin n Cancel */}
          <div className="grid grid-cols-2 gap-3 text-white font-semibold">
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="bg-red-500 hover:bg-red-600 px-3 py-2 rounded-md"
            >
              Kembali
            </button>
            <button
              type="button"
              onClick={handleSubmit}
              className="bg-blue-500 hover:bg-blue-600 px-3 py-2 rounded-md"
            >
              {loading ? "Loading..." : "Simpan"}
            </button>
          </div>
        </form>

        {/* Footer */}
        <div className="w-full flex items-center justify-center p-3 bg-gray-500 text-white">
          <p className="text-xl font-semibold">Danela Net -||- Andri Studio</p>
        </div>
      </div>
    </div>
  );
};
